import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class InstallationServicesDetailsLinksApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.InstallationServicesDetailsLinks;

  constructor(private label: string) {}

  getPayload(): any {
    return {
      item: this.label,
    };
  }
}
